export default __webpack_public_path__ + "static/media/panabaka-bhulakshmi.0dd752d6.png";